declare global {
  interface Window {
    clarity?: (action: string, ...args: any[]) => void;
  }
}

export function initializeClarity(projectId?: string): void {
  if (!import.meta.env.PROD) {
    return;
  }

  const defaultProjectId = 'u9put8pims';
  const clarityId = projectId || import.meta.env.VITE_CLARITY_PROJECT_ID || defaultProjectId;

  if (!clarityId) {
    if (import.meta.env.DEV) {
    }
    return;
  }

  if (window.clarity) {
    return;
  }

  (function (c: Window, l: Document, a: string, r: string, i: string, t: HTMLScriptElement | null, y: Element | null) {
    (c as any)[a] = (c as any)[a] || function (...args: any[]) {
      ((c as any)[a].q = (c as any)[a].q || []).push(args);
    };
    t = l.createElement(r) as HTMLScriptElement;
    t.async = true;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    if (y && y.parentNode) {
      y.parentNode.insertBefore(t, y);
    }
  })(window, document, "clarity", "script", clarityId, null, null);
}

export function trackClarityEvent(eventName: string): void {
  if (window.clarity) {
    window.clarity('event', eventName);
  }
}

export function identifyClarityUser(userId: string, sessionId?: string): void {
  if (window.clarity) {
    window.clarity('identify', userId, sessionId);
  }
}

